export const createTraySchema = ({ getSizeString, getPriceString, getAvailableCount }) => {
  return {
    title: 'Tray Details',
    summary: {
      title: 'Details',
      fields: [
        { key: 'brand', label: 'Brand' },
        { key: 'stock', label: 'Stock' },
        {
          key: 'available',
          label: 'Available',
          getValue: (row) => getAvailableCount ? getAvailableCount(row) : (row.available ?? row.stock ?? ''),
        },
        {
          key: 'size',
          label: 'Size',
          getValue: (row) => getSizeString(row),
        },
        {
          key: 'price',
          label: 'Price',
          getValue: (row) => getPriceString(row),
        },
      ],
    },
    sections: [
      {
        title: 'Notes',
        fields: [{ key: 'notes', label: 'Notes' }],
      },
    ],
  };
};
